import { axiosInstanceV1 } from "@bn/api";

export const resendConfirmationEmail = async (
  token: string | undefined,
  params: { email: string }
) => {
  const { data } = await axiosInstanceV1.post<undefined>(
    `/users/resendRegistrationConfirmation`,
    {},
    {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return data;
};
